import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    container: 'p-2 bg-white flex gap-1 ring ring-grey-70 ring-inset shadow-xs items-center relative',
    iconInfo: 'c-grey-10',
    message: 'body-4 c-black py-1'
  },
  closeIconSize: 'sm'
} satisfies VfConfig['notification']
